module.exports = __webpack_public_path__ + "img/partner_10.8c140c73.png";